import React from 'react';
import './form-layout.scss';

export function FormLayout({ children }) {
  const items = Array.isArray(children) ? children : [children];

  return (
    <div className="FormLayout">
      <div className="container">
        {items
          .filter((child) => !!child)
          .map((child, index) => (
            <div className="layout-item" key={index}>
              {child}
            </div>
          ))}
      </div>
    </div>
  );
}
